import { Controller } from "@hotwired/stimulus"

// Video elements adopted from Turbo Drive's detached response document fail
// resource selection (MEDIA_ERR_SRC_NOT_SUPPORTED) and render with a disabled
// play button. Replacing the element with a clone creates a fresh media element
// in the live document, which honors preload="none" — unlike load(), which
// makes Chrome buffer ahead as if preload="auto".
export default class extends Controller {
  connect() {
    if (this.element.error) this.element.replaceWith(this.element.cloneNode(true))
  }
}
